import React from 'react';

type Props = {
  now: Date;
  startDate: Date;
  endDate: Date;
  children: React.ReactNode;
};

export const TriggeredByDateMessageComponent: React.FC<Props> = (props: Props) => {
  if (props.now >= props.startDate && props.now <= props.endDate) {
    return <>{props.children}</>;
  } else {
    return null;
  }
};
